import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import shortid from 'shortid';

class ChecklistFormInpu extends Component {
  static propTypes = {
    // Required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,

    //Optional
    errorMessage: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    selectOptions: PropTypes.array,
    children: PropTypes.object,
    showError: PropTypes.bool,
  }

  renderLabel(label) {
    return label
    ? (
        <label>{label}</label>
      )
    : ''
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : '';
  }

  handleChange = (inputName, index) => {
    this.props.onChange(inputName, index)
  }

  render() {
    const {
      errorMessage,
      showError,
      label,
      name,
      optionalClasses,
      options
    } = this.props;

    return (
      <div
        className={`checklist-form-input${optionalClasses ? ' ' + optionalClasses : ''}${showError && errorMessage ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        {
          options.map((option, index) => {
            let optionId = shortid.generate();
            return (
              <div className="checkbox-container" key={optionId}>
                <input
                  id={optionId}
                  name={name}
                  type="checkbox"
                  checked={option.value}
                  onChange={(event) => this.handleChange(event.target.name, index)}
                />
                  <div
                    className="label"
                    data-target={name}
                    htmlFor={optionId}
                    onClick={(event) => this.handleChange(event.currentTarget.dataset.target, index)}
                  >
                    {option.label}
                  </div>
              </div>
            );
          })
        }
        {showError && this.renderErrorMessage(errorMessage)}
      </div>
    )
  }
}


export default ChecklistFormInpu;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/ChecklistFormInput.js